/**
 * Cohort sheet periods are stored cumulative. Derive display/export values here.
 */

export function getCohortPeriodValue(period, prevPeriod, metric, periodType) {
  if (!period) {
    return null;
  }
  const cumulative =
    metric === 'revenue'
      ? Number(period.revenue) || 0
      : Number(period.roas) || 0;

  if (periodType === 'cumulative') {
    return cumulative;
  }

  if (!prevPeriod) {
    return cumulative;
  }
  const prevCumulative =
    metric === 'revenue'
      ? Number(prevPeriod.revenue) || 0
      : Number(prevPeriod.roas) || 0;
  return cumulative - prevCumulative;
}

export function formatCohortPeriodValue(value, metric) {
  if (value == null || Number.isNaN(value)) {
    return '—';
  }
  if (metric === 'revenue') {
    return `$${Math.round(value).toLocaleString()}`;
  }
  return `${(value * 100).toFixed(1)}%`;
}

export function findPeriodByMob(periods, mob) {
  return periods?.find((entry) => entry.mob === mob) ?? null;
}
